import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import idx from 'idx';
import { getVoteStats } from 'presentations/utils';
import { LoadingIndicator } from 'common/components/preloader';
import Meta from 'project/containers/meta';
import PresentationTabs from 'presentations/containers/tabs';

export default class Presentation extends Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    const curId = idx(this.props, _ => _.params.presentationId);
    const prevId = idx(prevProps, _ => _.params.presentationId);
    if (curId !== prevId) {
      this.fetchData();
    }
  }

  fetchData() {
    this.props.fetch();
    this.props.fetchParticipants();
    this.props.fetchRevisions();
  }

  render() {
    const { presentation, participants, revisions, update, children } = this.props;

    if (!presentation) {
      return <LoadingIndicator />;
    }

    const isOpen = presentation.status === 'open';
    const voteStats = getVoteStats({ presentation, revisions, participants });

    return (
      <div className="presentation-wrapper">
        <Meta title="Presentations" />
        <div className="stats-container">
          <div className="row align-center presentation-stats">
            <div className="columns small-6 medium-4">
              <span className="stat-label">Status</span>
              <div className="stat-value">{ presentation.status }</div>
            </div>
            <div className="columns small-5 medium-4">
              <span className="stat-label">Participants</span>
              <div className="stat-value">{ participants.length }</div>
            </div>
            <div className="columns small-5 medium-4">
              <span className="stat-label">Total Votes</span>
              <div className="stat-value">
                { voteStats.voteCount }
                <span className="max-value"> / { voteStats.maxVoteCount }</span>
              </div>
            </div>
            <div className="columns small-16 medium-4 align-middle">
              <button className="btn btn-primary btn-toggle"
                  onClick={partial(update, { status: (isOpen? 'closed' : 'open') })}>
                { isOpen? 'Close' : 'Reopen' } Presentation
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="columns small-16 large-12">
            <h3 className="presentation-name">{ presentation.name }</h3>
            <div className="presentation-tabs">
              <PresentationTabs />
              { children }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Presentation.propTypes = {
  fetch: PropTypes.func.isRequired,
  fetchParticipants: PropTypes.func.isRequired,
  fetchRevisions: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  presentation: PropTypes.object,
  participants: PropTypes.array.isRequired,
  revisions: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/presentation.jsx